export default __webpack_public_path__ + "static/media/7Loop.8826efcd.mp4";